// src/pages/HeatRecoveryPage.js
import React, { useState, useEffect, useRef } from 'react';
import Navbar from '../components/NavBar'; // ✅ NAVBAR entegresi
import { motion, AnimatePresence } from 'framer-motion';
import HeatRecoveryForm from '../components/HeatRecoveryForm';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useNavigate, useLocation } from 'react-router-dom';

const API_BASE_URL = 'https://klima-backend-ggo2.onrender.com';



function createNewUnit(id) {
  return {
    id,
    type: 'hru',
    unitName: `IGK-${id.toString().padStart(2, '0')}`,
    deviceType: '',
    airflow: '',
    pressureLoss: '',
    efficiency: '',
    heater: '',
    cooler: '',
    advancedEnabled: false,
  };
}

function HeatRecoveryPage() {
  const [projectName, setProjectName] = useState('');
  const [location, setLocation] = useState('');
  const [hruNotes, setHruNotes] = useState('');
  const [climateData, setClimateData] = useState({
    altitude: '',
    winterDB: '',
    summerDB: '',
    summerWB: '',
  });

  const [allUnits, setAllUnits] = useState([]);
  const [hruUnits, setHruUnits] = useState([createNewUnit(1)]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [username, setUsername] = useState('');

  const pdfRef = useRef();

  const navigate = useNavigate();
  const locationState = useLocation();
  const queryParams = new URLSearchParams(locationState.search);
  const editProjectId = queryParams.get('edit');

  useEffect(() => {
  const token = localStorage.getItem('token');
  if (token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      setUsername(payload.username || 'Ziyaretçi');
    } catch {
      setUsername('Ziyaretçi');
    }
  } else {
    setUsername('Ziyaretçi');
  }
}, []);

  
  useEffect(() => {
    if (editProjectId) {
      const token = localStorage.getItem('token');
      fetch(`${API_BASE_URL}/api/projects/${editProjectId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(res => res.json())
        .then(data => {
          setProjectName(data.projectName || '');
          setLocation(data.location || '');
          setClimateData({
            altitude: data.altitude || '',
            winterDB: data.winterDryTemp || '',
            summerDB: data.summerDryTemp || '',
            summerWB: data.summerWetTemp || '',
          });

          if (Array.isArray(data.units)) {
            setAllUnits(data.units);
            const hruFiltered = data.units
              .filter(u => u.type === 'hru')
              .map((u, i) => ({
                ...createNewUnit(i + 1),
                ...u,
                id: u.id ?? i + 1,
                unitName: u.unitName ?? `IGK-${(i + 1).toString().padStart(2, '0')}`,
              }));
            setHruUnits(hruFiltered.length > 0 ? hruFiltered : [createNewUnit(1)]);
          }

          setUploadedFiles(data.uploadedFiles || []);
setHruNotes(data.hruNotes || '');

        });
    }
  }, [editProjectId]);



  const handleUnitChange = (id, newData) => {
    setHruUnits(hruUnits.map((u) => (u.id === id ? { ...u, ...newData } : u)));
  };

  const handleCopyUnit = (unit) => {
    const newId = hruUnits.length + 1;
    const newUnit = {
      ...unit,
      id: newId,
      unitName: `IGK-${newId.toString().padStart(2, '0')}`,
    };
    setHruUnits([...hruUnits, newUnit]);
  };

  const handleDeleteUnit = (id) => {
    if (window.confirm('Bu IGK cihazını silmek istediğinize emin misiniz?')) {
      setHruUnits(prev => prev.filter(unit => unit.id !== id));
    }
  };

  const handleFileUpload = async (e) => {
    const files = e.target.files;
    const formData = new FormData();
    for (let file of files) {
      if (file.size > 5 * 1024 * 1024) {
        alert(`${file.name} dosyası 5 MB'tan büyük.`);
        return;
      }
      formData.append('files', file);
    }

    try {
      const res = await fetch(`${API_BASE_URL}/api/upload`, {
        method: 'POST',
        body: formData,
      });
      const result = await res.json();
      setUploadedFiles(result.uploadedFiles);
    } catch {
      alert('Yükleme başarısız.');
    }
  };

  const generatePDF = () => {
    const input = pdfRef.current;
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
      heightLeft -= pdf.internal.pageSize.getHeight();

      while (heightLeft > 0) {
        position -= pdf.internal.pageSize.getHeight();
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
        heightLeft -= pdf.internal.pageSize.getHeight();
      }

      pdf.save('isi_geri_kazanim_cihazi.pdf');
    });
  };

  const handleSaveProject = async () => {
    if (username === 'Ziyaretçi') {
  alert('Projeyi Kaydedebilmek İçin Lütfen Giriş Yapınız');
  return;
}
    const updatedUnits = [
      ...allUnits.filter(u => u.type !== 'hru'),
      ...hruUnits.map((u, i) => ({
        ...u,
        type: 'hru',
        id: u.id ?? i + 1,
        unitName: u.unitName ?? `IGK-${(i + 1).toString().padStart(2, '0')}`,
      })),
    ];

    const data = {
      projectName,
      location,
      hruNotes, // ✅ bunu ekle
      altitude: Number(climateData.altitude),
      winterDryTemp: Number(climateData.winterDB),
      summerDryTemp: Number(climateData.summerDB),
      summerWetTemp: Number(climateData.summerWB),
      units: updatedUnits,
      uploadedFiles,
      updatedAt: new Date().toISOString(),
    };

    const token = localStorage.getItem('token');
    const method = editProjectId ? 'PUT' : 'POST';
    const endpoint = editProjectId
      ? `${API_BASE_URL}/api/projects/${editProjectId}`
      : `${API_BASE_URL}/api/projects`;

    try {
      const res = await fetch(endpoint, {
        method,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });
      if (!res.ok) throw new Error('Proje kaydedilemedi');
      alert('✅ Proje kaydedildi.');
      navigate('/panel');
    } catch (err) {
      alert('❌ Kayıt hatası: ' + err.message);
    }
  };

return (
  <>
    <Navbar username={username} />
    <div style={{ padding: 20, maxWidth: 1400, margin: 'auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
  <h1>Isı Geri Kazanım Cihazı</h1>

</div>


     <div ref={pdfRef} className="pdf-section">
  <div className="form-row align-center" style={{ position: 'relative' }}>
    <label>Proje İsmi:</label>
    <input
      type="text"
      value={projectName}
      onChange={(e) => setProjectName(e.target.value)}
      readOnly={username === 'Ziyaretçi'}
      placeholder={username === 'Ziyaretçi' ? '' : 'Proje ismini giriniz'}
      style={{
        backgroundColor: username === 'Ziyaretçi' ? '#f0f0f0' : '#fff',
        border: '1px solid #ccc',
        borderRadius: 6,
        padding: '8px 10px',
        fontSize: '16px',
        height: 38,
        lineHeight: '1.2',
        width: '200px',
        marginRight: 12,
        boxSizing: 'border-box',
        cursor: username === 'Ziyaretçi' ? 'not-allowed' : 'auto',
      }}
      title={
        username === 'Ziyaretçi'
          ? 'Değer girebilmek için lütfen giriş yapınız.'
          : ''
      }
    />
  </div>

  <div className="form-row align-center" style={{ position: 'relative' }}>
    <label>Proje Konumu:</label>
    <input
      type="text"
      value={location}
      disabled
      style={{
        backgroundColor: '#f0f0f0',
        border: '1px solid #ccc',
        borderRadius: 6,
        padding: '8px 10px',
        fontSize: '16px',
        height: 38,
        lineHeight: '1.2',
        width: '200px',
        marginRight: 12,
        boxSizing: 'border-box',
        cursor: username === 'Ziyaretçi' ? 'not-allowed' : 'auto',
      }}
      title={
        username === 'Ziyaretçi'
          ? 'Değer girebilmek için lütfen giriş yapınız.'
          : ''
      }
    />

  <span className="climate-info">
    Rakım: {climateData.altitude} m | Kış KT: {climateData.winterDB} °C | Yaz KT: {climateData.summerDB} °C | Yaz YT: {climateData.summerWB} °C
  </span>
</div>

        <AnimatePresence>
          {hruUnits.map((unit) => (
            <motion.div
              key={unit.id}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.3 }}
              style={{ position: 'relative', paddingTop: 40, marginBottom: 30 }}
              className="unit-card"
            >
              <button
                onClick={() => handleDeleteUnit(unit.id)}
                style={{
                  position: 'absolute',
                  top: 10,
                  right: 10,
                  backgroundColor: '#e53935',
                  color: 'white',
                  border: 'none',
                  borderRadius: 6,
                  padding: '4px 10px',
                  fontSize: 13,
                  cursor: 'pointer',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                }}
              >
                Sil
              </button>
              <HeatRecoveryForm
                unit={unit}
                onChange={(newData) => handleUnitChange(unit.id, newData)}
                onCopy={() => handleCopyUnit(unit)}
              />
              <button className="btn-copy" onClick={() => handleCopyUnit(unit)}>
                📝 {unit.unitName} Cihazını Kopyala
              </button>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>

      <button
        className="btn-add"
        onClick={() => setHruUnits([...hruUnits, createNewUnit(hruUnits.length + 1)])}
      >
        ➕ Yeni IGK Cihazı Ekle
      </button>

      <div style={{ margin: '20px 0' }}>
  <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 6 }}>Notlar:</label>
  <textarea
    value={hruNotes}
onChange={(e) => setHruNotes(e.target.value)}
    placeholder="Varsa ekstra notlarınızı buraya yazabilirsiniz..."
    style={{
      width: '100%',
      minHeight: 100,
      padding: '10px',
      fontSize: '15px',
      border: '1px solid #ccc',
      borderRadius: 6,
      resize: 'vertical',
    }}
  />
</div>


      <div className="btn-group" style={{ display: 'flex', gap: 10 }}>
  <button className="btn-save" onClick={handleSaveProject}>
    💾 Projeyi Kaydet
  </button>
  <button className="btn-pdf" onClick={generatePDF}>
    📄 PDF Oluştur 
  </button>
  <button
    onClick={() => navigate('/panel')}
    style={{
      backgroundColor: '#9e9e9e',
      color: 'white',
      padding: '10px 16px',
      border: 'none',
      borderRadius: 6,
      fontSize: 15,
      fontWeight: 'bold',
      fontFamily: 'Arial, sans-serif',
      cursor: 'pointer',
    }}
  >
    Vazgeç
  </button>
</div>

   </div>
  </>

  );
}

export default HeatRecoveryPage;
